import { jsx, jsxs } from "react/jsx-runtime";

const k = { jsx, jsxs };

export function TodayPanel({
  Title: V,
  tasks: n,
  onOpenTask,
  onNewTask,
  NextIcon: S,
  AddIcon: D,
}) {
  return (0, k.jsxs)(`section`, {
    className: `card today`,
    children: [(0, k.jsx)(V, {
      title: `Para hoy`,
      sub: `Tu foco inmediato`
    }), n.slice(0, 4).map(e => (0, k.jsxs)(`button`, {
      className: `taskquick`,
      onClick: () => onOpenTask(e),
      children: [(0, k.jsxs)(`span`, {
        children: [(0, k.jsx)(`b`, {
          children: e.title
        }), (0, k.jsxs)(`small`, {
          children: [e.date, ` · `, e.status]
        })]
      }), (0, k.jsx)(S, {})]
    }, e.id)), (0, k.jsxs)(`button`, {
      className: `link`,
      onClick: onNewTask,
      children: [(0, k.jsx)(D, {}), `Nueva tarea`]
    })]
  });
}
